import React, { useEffect, useContext, useState } from 'react'
import { useHistory } from "react-router-dom"

import localise from '../../tools/localise'
import { ResultContext } from '../../contexts/resultContext'
import { SetupContext } from '../../contexts/setupContext'
import { ClinicContext } from '../../contexts/clinicContext'
import CochlearAPI from '../../services/cochlearAPI'
import config from '../../config/config'

import './result.scss'

export default function Result(props) {

  const history = useHistory()

  const { result } = useContext(ResultContext)
  const { setLoginDetails, loginDetails } = useContext(SetupContext)
  const { clinic } = useContext(ClinicContext)
  
  const [downloading, setDownloading] = useState(false)
  const [downloadError, setDownloadError] = useState(null)
  const [showResults, setShowResults] = useState(false)

  const t = 'result'

  const onStartAgain = () => {
    setLoginDetails(null)
    history.push('/')
  }

  const toggleResults = () => {
    setShowResults(!showResults)
  }

  const downloadCSV = async () => {
    setDownloading(true)
    setDownloadError(null)
    
    try {
      const sessionId = result && result.id
      const clinicId = clinic && clinic.clinicId
      
      if (!sessionId || !clinicId) {
        throw new Error('Missing session or clinic information')
      }
      
      const { content, filename } = await CochlearAPI.download(sessionId, clinicId, loginDetails)
            
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
      
      if (isIOS) {
        const dataUri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(content)
        const link = document.createElement('a')
        link.href = dataUri
        link.download = filename
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      }
      
    } catch (error) {
      console.error('Download failed:', error)
      setDownloadError('Failed to download results. Please try again.')
    } finally {
      setDownloading(false)
    }
  }

  // Calculate results
  const totalQuestions = (result && result.actualTestProgress && result.actualTestProgress.attempted) || 0
  const correctCount = (result && result.actualTestScore && result.actualTestScore.score) || 0
  const percentage = totalQuestions > 0 ? ((correctCount / totalQuestions) * 100).toFixed(1) : 0

  return (
    <div className='result layout-1'>
      <div className='content'>

        <button type="button" className='btn btn-compact btn-start-again' onClick={onStartAgain}>
          {localise.getString(t + '.startAgain')}
        </button>

        <section className='resulttext' aria-label='region'>
          <img src={config.getImage('tick-icon.png')} className='icon' alt='tick-icon' />
        </section>

        <h1>{localise.getString(t + '.title')}</h1>
        <div className='results-toggle-section'>
          <button 
            className={`btn-toggle-results ${showResults ? 'active' : ''}`}
            onClick={toggleResults}
          >
            {showResults ? localise.getString(t + '.hideResults') : localise.getString(t + '.showResults')}
          </button>

          <div className={`results-display ${!showResults ? 'hidden' : ''}`}>
            <div className='results-content'>
              <p className='score-text'><strong>{localise.getString(t + '.score')}:</strong> {correctCount}/{totalQuestions} {localise.getString(t + '.correct')}</p>
              <p className='percentage-text'><strong>{localise.getString(t + '.percentage')}:</strong> {percentage}%</p>
            </div>
          </div>
        </div>

        <div className='download-section'>
          <button 
            className='btn btn-next' 
            onClick={downloadCSV} 
            disabled={downloading}
            aria-label={localise.getString(t + '.downloadReport')}
            style={{minWidth: '240px'}}
          >
            {downloading ? (
              <>
                <img src={config.getImage('ajax-loader.gif')} alt="loading" style={{width: '20px', marginRight: '8px'}} />
              </>
            ) : (
              <>
                {localise.getString(t + '.downloadReport')}
                <span className='arrow'></span>
              </>
            )}
          </button>
          {downloadError && <div className='error-message'>{downloadError}</div>}
        </div>
      </div>
    </div>
  )
}